import { useCallback, useState } from "react";

export const useSelection = () => {
  const [selected, setSelected] = useState(new Set());
  const toggle = useCallback((id) => setSelected((s) => { const n = new Set(s); n.has(id) ? n.delete(id) : n.add(id); return n; }), []);
  const setMany = useCallback((ids, on) => setSelected((s) => { const n = new Set(s); ids.forEach((id) => (on ? n.add(id) : n.delete(id))); return n; }), []);
  const clear = useCallback(() => setSelected(new Set()), []);
  return { selected, toggle, setMany, clear };
};

export const useSort = (initial = { key: "name", dir: "asc" }) => {
  const [sort, setSort] = useState(initial);
  const onSort = (key) => setSort((s) => ({ key, dir: s.key === key && s.dir === "asc" ? "desc" : "asc" }));
  return { sort, onSort };
};

export const matchesSearch = (l, q) => !q || `${l.name} ${l.email}`.toLowerCase().includes(q.toLowerCase().trim());
